




import Vue from 'vue'
export default Vue.extend({
  props: {
    status: {
      type: Object,
      required: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    diameter: {
      type: Number,
      default: 18,
    },
  },
  computed: {
    eventIndicatorCircleClass() {
      let type = this.status && this.status.type
      if (type == 'Good') {
        type += this.light ? '-Light' : '-Dark'
      }
      return ['Circle-Indicator', 'Indicator-' + type]
    },
    cssVars() {
      return {
        '--diameter': this.diameter + 'px',
      }
    },
  },
})
